/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function IntegrationsUninstall({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M12.14 13.41a1.94 1.94 0 0 1-.848.847c-.415.212-.959.212-2.046.212h-.452v-1.132a1.456 1.456 0 0 0-2.911 0v1.132h-.777c-1.086 0-1.63 0-2.045-.212a1.94 1.94 0 0 1-.848-.848C2 12.994 2 12.451 2 11.364v-.13a.97.97 0 0 1 .97-.97v0a1.617 1.617 0 1 0 0-3.234v0c-.535 0-.984-.435-.957-.97.017-.318.053-.545.135-.743a1.94 1.94 0 0 1 1.05-1.05c.357-.148.81-.148 1.713-.148h.647v-.97a1.617 1.617 0 1 1 3.235 0v.97h3.346M10.328 10.47l3.814-3.815M14.08 10.47l-3.815-3.815" /></svg>;
}
;